import { InjectionToken } from '@angular/core';

export interface BuildInfo {
    buildNumber: string;
    gitSha: string;
    buildDate: string;
    buildMachine: string;
    spacebotVersion: string;
}

export const BUILD_INFO = new InjectionToken<BuildInfo>('BUILD_INFO');
